import { render, staticRenderFns } from "./KQuestionRadioGroup.vue?vue&type=template&id=6f2de9a3&scoped=true&"
import script from "./KQuestionRadioGroup.vue?vue&type=script&lang=js&"
export * from "./KQuestionRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./KQuestionRadioGroup.vue?vue&type=style&index=0&id=6f2de9a3&prod&scoped=true&lang=css&"
import style1 from "./KQuestionRadioGroup.vue?vue&type=style&index=1&id=6f2de9a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2de9a3",
  null
  
)

export default component.exports